import { captureAction } from '@smg-real-estate/browser-rum';
import { onMounted } from 'vue';

import { useNavigationStore } from '@/stores/navigation';

/**
 * Register a listener that will refresh the page if there is a chunk preload error.
 * For example, after a new build is deployed.
 */
export const usePreloadErrorHandler = () => {
  const navigationStore = useNavigationStore();

  const handlePreloadError = (event: Event) => {
    event.preventDefault();
    captureAction('Chunk preload error detected');

    // If we are redirecting to an external page (e.g. login), we don't care to reload the page
    // when there is an error like this. This was added to fix a bug where redirecting to an external
    // page would cause cancelling in-flight resource requests, which then caused a reload here, which
    // then caused the external redirection to get cancelled by the browser (though only safari and firefox).
    if (!navigationStore.redirectingToExternal) {
      window.location.reload();
    }
  };

  onMounted(() => {
    window.addEventListener('vite:preloadError', handlePreloadError);
  });
};
